import styled from 'styled-components';

export default styled.div`
  opacity: 0.5;
  text-transform: uppercase;
  margin: 3px 5px 3px 0;
`;
